import { render, staticRenderFns } from "./StockDetail.vue?vue&type=template&id=f89d2928&scoped=true&"
import script from "./StockDetail.vue?vue&type=script&lang=ts&"
export * from "./StockDetail.vue?vue&type=script&lang=ts&"
import style0 from "./StockDetail.vue?vue&type=style&index=0&id=f89d2928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89d2928",
  null
  
)

export default component.exports